export const SET_SELECTED_STATUS_ACTION = 'selectedStatus';
export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_EMPRESA_ACTION = 'empresa';
export const SET_LOCAL_ENTREGA_ACTION = 'localEntrega';
export const SET_CENTRO_CUSTO_ACTION = 'centroCusto';
export const SET_PRODUTO_ACTION = 'produto';
export const SET_PROJETO_ACTION = 'projeto';
export const SET_RESPONSAVEL_ACTION = 'responsavel';
export const SET_FORNECEDOR_ACTION = 'fornecedor';
export const SET_DATA_INICIAL_ACTION = 'dataInicial';
export const SET_DATA_FINAL_ACTION = 'dataFinal';
export const SET_GRUPO_ACTION = 'grupo';
export const SET_SITUACAO_ACTION = 'situacao';
export const SET_FILTER_ACTION = 'filter';
export const SET_LIST_OPTIONS_ACTION = 'listOptions';
export const RESET_PAGINATION = 'resetPagination';
export const INIT_STATE_ACTION = 'initState';
export const SET_CURRENT_SESSION_STATE_ACTION = 'sessionState';
export const SET_VIEW_OPTION_ACTION = 'viewOption';
export const RESET_OPTIONS = 'resetOptions';
